module.exports = __webpack_public_path__ + "img/iphone-charging-GERMANY-en.40a2ed23.webp";